import {gql} from "@apollo/client";

export const unhideFireblocksVaultMutation = gql`
    mutation UnhideFireblocksVault($customerId: String!) {
        unhideFireblocksVault_Admin(customerId: $customerId)
    }
`